<template>
  <div>
    <article class="m-card-element m-card-element-design-7 m-card-primary">
      <img
        v-if="tarjeta.metadata.imagen"
        :alt="element.descripcion.nombre"
        id="tarjetaImagen"
        ref="imagen"
        :src="tarjeta.metadata.imagen"
      >
      <img
        v-else
        :alt="element.descripcion.nombre"
        :class="showMetadataValidationError && !isMetadataValid ? 'm-card-element-edition-image-error' : ''"
        id="tarjetaImagen"
        ref="imagen"
        src="@/assets/img/ds7.png"
      >
      <a
        class="m-card-element-edition-image-btn m-card-element-edition-image-btn-products m-card-element-edition-image-btn-7"
        href="#"
        @click.prevent="changeCardImage('inputImagen')"
      >
        <i class="far fa-image"></i> {{ $t('mFeedSectionContentCardEditionDesign7.buttonImage') }}
      </a>
      <input
        v-show="false"
        data-img-id="tarjetaImagen"
        name="imagen"
        id="inputImagen"
        ref="file"
        type="file"
        value=""
        @change="previewCardImage"
      >

      <div class="m-card-element-info-data">
        <h5
          v-if="element.descripcion.categoria !== undefined"
          key="categoryName"
        >
          {{ productoCategoriaNombre }}
        </h5>
        <h5
          v-else
          key="noCategoryName"
        >
          {{ $t('mFeedSectionContentCardDesing2.noCategoryName') }}
        </h5>

        <textarea
          :class="$v.element.descripcion.nombre.$error ? 'm-card-element-design-7-name a-input-danger' : 'm-card-element-design-7-name'"
          name="nombre"
          spellcheck="false"
          :value="element.descripcion.nombre"
          ref="nombre"
          @blur="changeElementNombre"
        >
        </textarea>
      </div>

      <div class="m-card-element-info-state">
        <div class="m-card-element-info-state-of-access">
          <h3
            v-if="element.estado.activo"
            key="available"
          >
            {{ $t('mFeedSectionContentCardDesing2.available') }}
          </h3>
          <h3
            v-else
            key="notAvailable"
          >
            {{ $t('mFeedSectionContentCardDesing2.notAvailable') }}
          </h3>
          <h4
            v-if="element.estado.visible"
            key="visible"
          >
            {{ $t('mFeedSectionContentCardDesing2.visible') }}
          </h4>
          <h4
            v-else
            key="hidden"
          >
            {{ $t('mFeedSectionContentCardDesing2.hidden') }}
          </h4>
        </div>
        <router-link
          class="m-card-element-info-state-of-price-contrast"
          :to="`/${$t('rPaths.product')}/${$route.params.id}/${$t('mEditionMenu.product.pricesAndPlans.subject')}`"
        >
          {{ productoPrecio }}
        </router-link>
      </div>
    </article>

    <p v-if="isAProductRoute">
      <a
        class="font-weight-bold text-link-hover-products"
        @click.prevent="changeCardType"
      >
        <i class="far fa-window-maximize margin-right-xsmall"></i>
        {{ $t('mEditionProductCard.selectCardTypes') }}
      </a>
    </p>

    <ul>
      <li>
        <small
          v-if="$v.element.descripcion.nombre.$error"
          class="text-color-danger"
        >
          {{ messageErrorNombre }}
        </small>
        <small
          v-if="!isFileExtensionValid"
          class="text-color-danger"
        >
          {{ messageErrorFileExtension }}
        </small>
        <small
          v-if="!isFileSizeValid"
          class="text-color-danger"
        >
          {{ messageErrorFileSize }}
        </small>
      </li>
      <li>
        <small
          v-if="showMetadataValidationError && !isMetadataValid"
          class="text-color-danger"
        >
          {{ messageErrorFileRequired }}
        </small>
      </li>
      <li>
        <small class="font-weight-light">
          <i>{{ $t('mFeedSectionContentCardEditionDesign7.messages.extensions') }}</i>
        </small>
      </li>
      <li>
        <small class="font-weight-light">
          <i>{{ $t('mFeedSectionContentCardEditionDesign7.messages.dimensions') }}</i>
        </small>
      </li>
      <li>
        <small class="font-weight-light">
          <i>{{ $t('mFeedSectionContentCardEditionDesign7.messages.nameLength') }}</i>
        </small>
      </li>
    </ul>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeFeedSectionContentCardEditionDesign7',

  props: {
    element: Object,
    esPago: Boolean,
    elementCategorias: Array,
    showMetadataValidationError: Boolean,
    videoUrlParsed: {
      type: [String, Boolean],
      default: false
    }
  },

  data () {
    return {
      isFileExtensionValid: true,
      isFileSizeValid: true,
      isMetadataValid: true,

      tarjeta: {
        tipo: 7,
        metadata: {
          imagen: ''
        }
      }
    }
  },

  validations: {
    element: {
      descripcion: {
        nombre: {
          maxLength: maxLength(120),
          minLength: minLength(5),
          required
        }
      }
    }
  },

  computed: {
    isAProductRoute () {
      return this.$route.name === 'products' || this.$route.name === 'product'
    },

    messageErrorFileExtension () {
      return this.$t('mFeedSectionContentCardEditionDesign7.validation.fileExtension')
    },

    messageErrorFileSize () {
      return this.$t('mFeedSectionContentCardEditionDesign7.validation.fileSize')
    },

    messageErrorFileRequired () {
      return this.$t('mFeedSectionContentCardEditionDesign7.validation.fileRequired')
    },

    messageErrorNombre () {
      return this.$validation.getValidationMessage('mFeedSectionContentCardEditionDesign7', this.$v.element.descripcion.nombre, 'nombre')
    },

    productoCategoriaNombre () {
      return this.elementCategorias.find(categoria => categoria.id_producto_categoria === this.element.descripcion.categoria).nombre
    },

    productoPrecio () {
      return this.esPago
        ? this.$t('mFeedSectionContentCardEditionDesign7.infoPrice.buy')
        : this.$t('mFeedSectionContentCardEditionDesign7.infoPrice.free')
    }
  },

  watch: {
    showMetadataValidationError () {
      if (this.showMetadataValidationError) {
        this.isMetadataValid = Object.values(this.tarjeta.metadata).find(md => md === '') === undefined
      }
    },

    'tarjeta.metadata': {
      deep: true,

      handler () {
        this.getValidationError()
      }
    }
  },

  created () {
    if (this.element.tarjeta.tipo === 7 && this.element.tarjeta.metadata) {
      this.tarjeta = Object.assign({}, { tipo: this.element.tarjeta.tipo,
        metadata: Object.assign({}, this.element.tarjeta.metadata) })
    }

    this.getValidationError()
  },

  mounted () {
    this.getReference()
  },

  methods: {
    changeCardType () {
      this.$emit('changeCardType', this.tarjeta.tipo)
    },

    changeCardImage (inputId) {
      document.getElementById(inputId).click()
    },

    changeElementNombre (event) {
      this.$v.element.descripcion.nombre.$touch()
      this.$emit('changeElementNombre', event.target.value)
      this.$emit('getValidationError', 'name', this.$v.$invalid)
      this.getReference()
    },

    getReference () {
      this.$emit('getReference', 'nombre', this.$refs.nombre)
      this.$emit('getReference', 'imagen', this.$refs.imagen)
    },

    getValidationError () {
      this.isMetadataValid = Object.values(this.tarjeta.metadata).find(md => md === '') === undefined
      this.$emit('getValidationError', 'card', !this.isMetadataValid)
      this.getReference()
    },

    previewCardImage (event) {
      let input = event.target
      this.isFileExtensionValid = this.$files.allowedFileExtension(input.files[0].name, 'image')
      this.isFileSizeValid = this.$files.allowedFileSize(input.files[0].size)
      if (input.files && input.files[0] && this.isFileExtensionValid && this.isFileSizeValid) {
        var reader = new FileReader()
        reader.onload = (e) => {
          document.getElementById(input.getAttribute('data-img-id')).src = e.target.result
          this.tarjeta.metadata.imagen = e.target.result
          this.$emit('changeElementCard', this.tarjeta)
          this.getReference()
        }
        reader.readAsDataURL(input.files[0])
      } else if (!this.isFileExtensionValid) {
        this.$modal.showModal('MoleculeFeedSectionContentCardEditionModalFileExtensionError', { seccion: this.isAnAssetRoute ? 'assets' : 'products' })
      } else if (!this.isFileSizeValid) {
        this.$modal.showModal('MoleculeContentEditorModalFileSizeError')
      }
    }
  }
}
</script>
